import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import RaceService from "../../src/Services/Race.service";
const RaceLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<Race[]>' is not assignable to type '(ids: string[]) => Promise<Race[]>'.
        fetchItemsById: (ids) => {
            return RaceService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return RaceService.searchAll(search);
        },
        optionRenderer: function optionRenderer(race) {
            return _jsx("span", { children: race.name });
        },
    });
};
export default RaceLookup;
